import React from "react";
import Reveal from "./Reveal";

const EngelliOdasi = () => {
  return (
    <div
      style={{
        padding: "clamp(3.5rem, 8vw, 5rem) 1.5rem",
        borderTop: "1px solid rgba(14, 27, 77, 0.08)",
      }}
    >
      <Reveal>
      <div style={{ maxWidth: "820px", margin: "0 auto" }}>
        <h1
          style={{
            marginBottom: "1.5rem",
            color: "#0e1b4d",
            fontSize: "clamp(1.6rem, 3vw, 2.2rem)",
          }}
        >
          Engelli Odası Nitelikleri
        </h1>

        <p style={{ lineHeight: 1.7, marginBottom: "1.25rem", color: "#333" }}>
          Tesisimiz oda sayısı kapsamında turizm kanununa tabi değildir. Buna
          bağlı olarak tesisimizde engelli odası bulunması için bir zorunluluk
          yoktur. Ancak Kültür ve Turizm Bakanlığı’nın yayımladığı yönetmelikte
          yer alan standartlar aşağıdaki gibidir.
        </p>

        <h2
          style={{
            marginTop: "2rem",
            marginBottom: "1rem",
            color: "#0e1b4d",
            fontSize: "1.35rem",
          }}
        >
          Yasal Yönetmelik
        </h2>

        <p style={{ lineHeight: 1.7, marginBottom: "1.5rem", color: "#333" }}>
          01.06.2019 tarihinde yürürlüğe giren “Turizm Tesislerinin
          Niteliklerine İlişkin Yönetmelik”te turizm tesislerinde bedensel
          engelliler için sağlanması gereken birtakım standartlar
          tanımlanmaktadır.
        </p>

        <p style={{ lineHeight: 1.7, marginBottom: "1.5rem", color: "#333" }}>
          Kültür ve Turizm Bakanlığı'nın yayımladığı tebliğe göre:
          <br />• 80 odalı ve 4–5 yıldızlı otellerde en az <b>1</b> oda,
          <br />• 200 odalı otellerde en az <b>2</b> oda,
          <br />• 300 odalı otellerde en az <b>3</b> oda engellilere uygun
          olmalıdır.
          <br />
          Minimum oda sayısı her <b>100 oda için 1</b> adet artırılır.
        </p>

        <h2
          style={{
            marginTop: "2rem",
            marginBottom: "1rem",
            color: "#0e1b4d",
            fontSize: "1.35rem",
          }}
        >
          Yönetmelikte Tanımlanan Engelli Odası Gereklilikleri
        </h2>

        <ul
          style={{
            lineHeight: 1.8,
            paddingLeft: "1.25rem",
            color: "#333",
          }}
        >
        <li>
          Odalar bedensel engellilerin rahatça hareket edebileceği şekilde
          düzenlenir, sivri köşeli veya dengesiz eşyalar kullanılmaz.
        </li>
        <li>Oda giriş kapısı genişliği en az 85 cm olmalıdır.</li>
        <li>
          Zemin kaygan olmamalı; kalın, tutucu özellikte halılar tercih
          edilmemelidir.
        </li>
        <li>
          Dolap kapıları sürgülü olmalı ve askı yüksekliği en fazla 140 cm
          olmalıdır.
        </li>
        <li>
          Elektrik düğmeleri ve prizler zeminden 40–120 cm yükseklikte
          konumlandırılmalıdır.
        </li>
        <li>Yatak başucunda merkezi aydınlatma düğmesi bulunmalıdır.</li>

        <li style={{ marginTop: "20px" }}>
          <b>Banyo Gereklilikleri:</b>
        </li>

        <li>Banyo kapısı genişliği en az 85 cm olmalıdır.</li>
        <li>
          Eşik yapılması gerekiyorsa yükseklik en fazla 1,5 cm olacak şekilde
          pahlı yapılmalıdır.
        </li>
        <li>
          Klozet, lavabo ve bataryalar engelli kullanımına uygun şekilde
          düzenlenmelidir.
        </li>
        <li>
          Klozet etrafında 85–95 cm yükseklikte tutunma barları bulunmalıdır.
        </li>
        <li>
          Aynalar göz hizasında veya 10–15 derece eğimli olacak şekilde
          yerleştirilir; alt kenar yüksekliği maksimum 100 cm olmalıdır.
        </li>
        <li>
          Tekerlekli sandalyenin tam tur yapabilmesi için 150 cm çapında boş
          alan bulunmalıdır.
        </li>
        <li>
          Sabunluk, havluluk ve kağıtlık gibi aksesuarlar zeminden 50–120 cm
          yüksekliğe monte edilir.
        </li>
        <li>
          Duş veya küvet bölümü oturma alanı ve tutunma bantları ile
          desteklenmelidir. Resepsiyon bağlantılı acil durum alarmı da
          bulunmalıdır.
        </li>
      </ul>

        <p style={{ marginTop: "2rem", fontStyle: "italic", color: "#555" }}>
          Bu bilgiler, Kültür ve Turizm Bakanlığı tarafından yayımlanan
          yönetmelik esas alınarak hazırlanmıştır.
        </p>
      </div>
      </Reveal>
    </div>
  );
};

export default EngelliOdasi;
